import classNames from 'classnames';
import { compact } from 'lodash';
import type { FC } from 'react';
import React, { useContext } from 'react';

import '../../../../src/components/Filter.scss';
import Icon from '../../../../src/components/ui/Icon';
import ConfigRentContext from '../../../service/context/config-rent';
import useAppStoreRent from '../../../service/store/appRent';

const FilterRent: FC = () => {
  const appContext = useContext(ConfigRentContext);
  const { system, type, kontur, kontur_finder } = appContext || {};
  const {
    filter,
    setFilterAdvanced,
    availableFilter
  } = useAppStoreRent(state => state);
  const {
    search,
    system: systemFilter,
    type: typeFilter,
    kontur: konturFilter
  } = filter;

  const hasFilter = search || systemFilter || typeFilter || konturFilter;
  const systemList = compact(system);
  const typeList = compact(type);
  const konturList = compact(kontur);

  return (
    <div>
      <div className={classNames('filter-wrap filter-wrap-rent', { 'filter-wrap-rent--kontur-finder': kontur_finder })}>
        <div className="filter-item filter-item--full">
          <label>Gerätebezeichnung</label>
          <div className="filter-item-serach">
            <Icon icon="search" />
            <input
              onChange={event => setFilterAdvanced('search', event.target.value)}
              type="text"
              value={search}
              placeholder="Suche"
            />
          </div>
        </div>
        <div className="filter-item">
          <label>Produkt-Typ</label>
          <select
            onChange={event => setFilterAdvanced('type', event.target.value)}
            value={typeFilter}
          >
            <option value="">bitte wählen</option>
            {typeList.map(typeItem => {
              const isHidden = !availableFilter?.type?.includes(typeItem);

              return (
                <option
                  key={typeItem}
                  value={typeItem}
                  disabled={isHidden}
                >
                  {typeItem}
                </option>
              );
            })}
          </select>
        </div>
        <div className="filter-item">
          <label>Kontur</label>
          <select
            onChange={event => setFilterAdvanced('kontur', event.target.value)}
            value={konturFilter}
          >
            <option value="">bitte wählen</option>
            {konturList.map(konturItem => {
              const isHidden = !availableFilter?.kontur?.includes(konturItem);

              return (
                <option
                  key={konturItem}
                  value={konturItem}
                  disabled={isHidden}
                >
                  {konturItem}
                </option>
              );
            })}
          </select>
        </div>
        {kontur_finder ? (
          <div className="filter-item filter-item--kontur-finder">
            <label>Unsicher, welche Kontur?</label>
            <a
              className="btn btn-xs"
              href={kontur_finder}
              target="_blank"
              rel="noopener noreferrer"
            >
              zum Konturenfinder
            </a>
          </div>
        ) : (
          <div className="filter-item">
            <label>System</label>
            <select
              onChange={event => setFilterAdvanced('system', event.target.value)}
              value={systemFilter}
            >
              <option value="">bitte wählen</option>
              {systemList.map(systemItem => {
                const isHidden = !availableFilter?.system?.includes(systemItem);

                return (
                  <option
                    key={systemItem}
                    value={systemItem}
                    disabled={isHidden}
                  >
                    {systemItem}
                  </option>
                );
              })}
            </select>
          </div>
        )}
      </div>
      <div className="filter-reset">
        <button
          className={classNames('btn--reset', {
            disabled: !hasFilter
          })}
          onClick={() => setFilterAdvanced('reset', '')}
        >
          Filter zurücksetzen
        </button>
      </div>
    </div>
  );
};

export default FilterRent;
